export const pathMatch = {
  goodsDetail: '/goodsDetail?goodsId=',
  special: '/special?id=',
  landingPage: ''
}
